// extracted by mini-css-extract-plugin
module.exports = {"vendors":"vendors_vendors__gqA8t"};